import "babel-polyfill";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {mobileNav} from "./modules/mobileNav";
import {stickyHeader} from "./modules/stickyHeader";
import {tabs} from "./modules/tabs";
import {inputHolderAnimation} from "./modules/inputHolderAnimation";
import {headerMenuSlider} from "./modules/headerMenuSlider";
import {scrollTop} from "./modules/scrollTop";
import {accordion} from "./modules/accordion";
import {historyScroll} from "./modules/historyScroll";
import {quoteSlider} from "./modules/quoteSlider";
import {partnersSlider} from "./modules/partnersSlider";
import {videoBlock} from "./modules/videoBlock";
import {popupBio} from "./modules/popupBio";
import {customSelect} from "./modules/customSelect";
import {anchorLinks} from "./modules/anchorLinks";
import {projectsSlider} from "./modules/projectsSlider";


binder({
    bounds: {
        "html": constants,
        ".header": [mobileNav, stickyHeader, headerMenuSlider],
        ".tabs-holder": tabs,
        "input": inputHolderAnimation,
        ".back-to-top": scrollTop,
        ".accordion": accordion,
        ".timeline-holder": historyScroll,
        ".quote-slider .slider": quoteSlider,
        ".partners-slider": partnersSlider,
        ".video-holder": videoBlock,
        ".popup-opener": popupBio,
        "select": customSelect,
        ".anchor-link": anchorLinks,
        ".projects-slider .slider": projectsSlider
    },
    runTests: false
});


// WEBPACK FOOTER //
// ./assets/js/global.js